export const CHECKOUT_STATUS_CHANGE = "CHECKOUT_STATUS_CHANGE"
